export const CUSTOMER_PORTAL_URL = (import.meta.env.VITE_CUSTOMER_PORTAL_URL || 'http://localhost:5174').replace(/\/$/, '');
